import React, { useEffect, useState, useRef } from 'react';
import { Suspense } from 'react';
import Navigation from './festival/Navigation';
import ContentPanel from './festival/ContentPanel';
import PlayButton from './festival/PlayButton';
import ExitMessage from './festival/ExitMessage';
import BoidSimulation from './festival/BoidSimulation';
import { COLORS, FONTS } from './shared/ContentData';

const FestivalRouter = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [isPlayMode, setIsPlayMode] = useState(false);
  const [activeSection, setActiveSection] = useState(null);
  const boidsStateRef = useRef(null);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  useEffect(() => {
    const handleKeyPress = (e) => {
      if (e.key === 'Escape' && isPlayMode) {
        setIsPlayMode(false);
      }
    };

    window.addEventListener('keydown', handleKeyPress);
    return () => window.removeEventListener('keydown', handleKeyPress);
  }, [isPlayMode]);

  useEffect(() => {
    // Update cursor style
    document.body.style.cursor = isPlayMode ? 'none' : 'auto';
    
    return () => {
      document.body.style.cursor = 'auto';
    };
  }, [isPlayMode]);

  const onBoidsUpdate = (newBoidsState) => {
    boidsStateRef.current = newBoidsState;
  };

  return (
    <div style={{ position: 'relative', height: '100vh', overflow: 'hidden' }}>
      <Suspense fallback={
        <div style={{ 
          height: '100vh', 
          width: '100vw', 
          backgroundColor: COLORS.background,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          fontFamily: FONTS.primary
        }}>
          Loading...
        </div>
      }>
        <BoidSimulation 
          isMobile={isMobile}
          isPlayMode={isPlayMode}
          initialBoidsState={boidsStateRef.current}
          onBoidsUpdate={onBoidsUpdate}
          activeSection={activeSection}
        />
        
        {!isPlayMode && (
          <>
            <Navigation 
              isMobile={isMobile}
              activeSection={activeSection}
              setActiveSection={setActiveSection}
            />
            <ContentPanel 
              activeSection={activeSection}
              setActiveSection={setActiveSection}
              isMobile={isMobile}
            />
            <PlayButton 
              isPlayMode={isPlayMode}
              setIsPlayMode={setIsPlayMode}
              isMobile={isMobile}
            />
          </>
        )}
        
        {isPlayMode && <ExitMessage />}
      </Suspense>
    </div>
  );
};

export default FestivalRouter;